import { getObjectName as n } from "../../../helpers/getObjectName.js";
import { sendToLurker as c } from "../../Lurker/Lurker.js";
var p = Object.defineProperty,
  o = Object.getOwnPropertySymbols,
  b = Object.prototype.hasOwnProperty,
  l = Object.prototype.propertyIsEnumerable,
  a = (t, r, e) => r in t ? p(t, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : t[r] = e,
  i = (t, r) => {
    for (var e in r || (r = {})) b.call(r, e) && a(t, e, r[e]);
    if (o) for (var e of o(r)) l.call(r, e) && a(t, e, r[e]);
    return t;
  };
const m = (t, r) => {
  c({
    eventType: "click",
    objectDetail: t,
    objectName: "navbar",
    data: i({
      page_name: n()
    }, r)
  });
};
export { m as sendClickEvent };